import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export type MuiSkeletonProps = SkeletonProps;

export const Skeleton = MUISkeleton;
